import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import parseCategories from 'utils/parseCategories';
import { useRouter } from 'next/router';
export default function useCategoryFilter({ id, query }) {
  const router = useRouter();
  const lang = router.locale ? router.locale : 'et';
  const [categories, setCategories] = useState([]);

  const { data, loading } = useQuery(query, {
    variables: { ids: id || ['2'] },
    context: { fetchOptions: { method: 'GET' }, headers: { store: lang } }
  });

  useEffect(() => {
    const groups = data?.categoryList[0]?.children;

    if (!id) {
      const categories = parseCategories(groups);
      setCategories(categories);
    } else {
      setCategories(groups);
    }
  }, [id, data]);

  return { categories, loading };
}
